import { AlertTriangle } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatDaysLeft, getSubscriptionState } from "../utils/subscription";

const PAYMENT_EMAIL = "ceo@mytravelstat.com";

export default function SubscriptionNotice() {
  const { user, company_id: companyId } = useAuth();
  const isClient = Boolean(user && user.role !== "admin" && companyId);
  const state = getSubscriptionState(user?.subscription_expires_on);
  const shortExpiresOn = state.expiresOn
    ? state.expiresOn.slice(0, 10).split("-").reverse().join(".")
    : "—";

  if (!isClient || (!state.isExpired && !state.isExpiringSoon)) {
    return null;
  }

  const messageLines = state.isExpired
    ? [
        `Срок оплаты истёк, поэтому доступ к аналитике временно ограничен. После оплаты сервис снова будет доступен. По вопросам оплаты напишите на ${PAYMENT_EMAIL}`,
      ]
    : [
        `До окончания оплаченного периода осталось ${formatDaysLeft(state.daysLeft ?? 0)}. Чтобы сохранить доступ к аналитике и отчётам, внесите оплату до ${shortExpiresOn}. Если нужна помощь с оплатой, напишите на ${PAYMENT_EMAIL}`,
      ];

  return (
    <div className="border-b border-red-200 bg-red-50 text-red-900">
      <div className="mx-auto flex max-w-[1800px] justify-center px-7 py-3 text-center text-sm font-medium">
        <div className="inline-flex items-center justify-center gap-3">
          <AlertTriangle size={20} className="shrink-0 text-red-600" />
          <div className="space-y-1">
            {messageLines.map((line) => (
              <div key={line}>{line}</div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
